// Stylesheet (imported here to avoid CSS ordering conflicts across entrypoints)
import "normalize.css";
import "shared/styles/icer-ui.scss";

import React from "react";
import { createRoot } from "react-dom/client";
import App from "ec/components/App";
import ErrorHandler from "ec/components/ErrorHandler";
import theme from "shared/theme";
import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import useAuthentication from "shared/hooks/useAuthentication";

// Polyfill for object-fit css property
import "objectFitPolyfill";

document.addEventListener("DOMContentLoaded", () => {
  const { isSignedIn = false, isDeviseView = false, root } = useAuthentication();
  const rootElement = createRoot(root);
  rootElement.render(
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <ErrorHandler>
          <App isSignedIn={isSignedIn} isDeviseView={isDeviseView} />
        </ErrorHandler>
      </MuiThemeProvider>
    </StyledEngineProvider>,
  );
});
